appReloadRun.$inject = ['$rootScope', '$state', 'LocalStorageFactory'];
export function appReloadRun($rootScope, $state, LocalStorageFactory) {

  $rootScope.$on('ws.app.reload',function(event){
    window.location.reload();
  });

  $rootScope.$on('ws.app.clean',function(event,data){
    LocalStorageFactory.clear();
    window.location.reload();
  });
}